$(document).on('keydown', function(e) {
    if (e.key === "ArrowUp" || e.key === "ArrowDown") {
        e.preventDefault(); // Prevents the default behavior of scrolling with the arrow keys
    }
});

// ------------------------- to disable right click ----------------------------
// document.addEventListener('contextmenu', event => event.preventDefault());
document.onkeydown = function (e) {
  // disable F12 key
  if(e.keyCode == 123) {
      return false;
  }
  // disable ctrl+u key
  if(e.ctrlKey && e.keyCode == 85) {
      return false;
  }
  console.log("Key Code: "+e.keyCode);
};

// ----------------------------- jquery for swatches --------------------------------
$ = jQuery;
 $(document).on('click', '.product-colorlist-item', function(e) {
    e.preventDefault();
    e.stopPropagation();
   
    // Check if variant URL exists - if yes, navigate to product page with variant
    var variantUrl = $(this).data('variant-url');
    if (variantUrl) {
      window.location.href = variantUrl;
      return;
    }
   
    // Fallback: Original image switching behavior (if no variant URL)
    // Fetch the 'data-url' attribute from the clicked swatch
    var img_url = $(this).data('url');
    if (img_url) {
      var update_img_url = img_url+"&width= 533";
      var srcset_url = img_url+"&width=165 165w,"+img_url+"&width=360 360w,"+img_url+"&width=533 533w,"+img_url+"&width=720 720w,"+img_url+"&width=940 940w,"+img_url+"&width=1066 1066w,"+img_url+" 1280w";
      $(this).parent().find('.product-colorlist-item').removeClass('active-swatch');
      $(this).addClass('active-swatch');
      // Find the closest ancestor containing the image with class 'card__media'
      var img_element = $(this).closest('.product-card-wrapper').find('.card__media img');
      // Update the image src and srcset with the new url from the clicked swatch
      img_element.attr('src', update_img_url);
      img_element.attr('srcset', srcset_url);

      var newWindowWidth = $(window).width();
      if (newWindowWidth < 600) {
        var $title = $(this).find(".swatch-title");
        if (!$title.length) {
          $(this).append('<span class="swatch-title scroll-trigger animate--slide-in">' + $(this).attr("title") + '</span>');
        }
      }
    }
  });

// ---------------------- single product thumbnail vertical slider ------------------------


$(document).ready(function () {
  $(".thumbnail-list").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    // autoplay: true,
    autoplaySpeed: 2000,
    vertical: true,
    verticalSwiping: true,
    infinite: false,
    arrows : false,
    prevArrow: '<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="Previous" role="button" style=""><img class="top-arrow" src="https://cdn.shopify.com/s/files/1/0890/7567/9528/files/Group_62.png?v=1727944328"></button>',
  nextArrow: '<button type="button" data-role="none" class="slick-next slick-arrow" aria-label="Next" role="button" style=""><img class="bottom-arrow" src="https://cdn.shopify.com/s/files/1/0890/7567/9528/files/Group_62.png?v=1727944328"></button>',
  });
});



// ---------------------- hero shoes slider  ------------------------

$(document).ready(function () {
  $("#middle-image-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    vertical: true,
    verticalSwiping: false,
    infinite: true,
    arrows : false,
     speed: 1500,
    pauseOnHover:false,
  });
});



// ---------------------- hero shoes slider for mobile ------------------------

$(document).ready(function () {
  $("#hero-main-middle-image-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    vertical: true,
    verticalSwiping: false,
    infinite: true,
    arrows : false,
     speed: 1500,
    pauseOnHover:false,
  });
});


// show hide chat icon

$(window).on('scroll', function() {
    if ($(this).scrollTop() >= 300) {
        $('#shopify-chat').fadeIn(); // or .show()
    } else {
        $('#shopify-chat').fadeOut(); // or .hide()
    }
});
